.filterItem {
  flex: 1 1 220px;
  min-width: 220px;
}

.filterItem :global(.ant-picker) {
  width: 100%;
}
